

import { sniff } from '@/util'

const defaultParams={
  title: 'ubox-范斯猫球星卡', // 分享四要素-标题
  desc: '一站式球星卡分享、交易、收藏平台', // 分享四要素-副标题
  link: location.href,
  imgUrl: 'https://cdn.shubox.com/ubox-fe/images/logo/logo132x132.png', // 分享四要素-图片地址,
}

/**
 * 微信二次分享配置
 *
 * @export
 * @param {}
 */
export default function wxReadyHandle(params) {
  if ( !sniff.isWechat ) return
  const wxConfig = {
    title: params?.title ?? defaultParams.title, // 分享四要素-标题
    desc: params?.description ?? defaultParams.desc, // 分享四要素-副标题
    link: params?.url ?? defaultParams.link,  // 分享四要素-链接
    imgUrl: params?.image ?? defaultParams.imgUrl, // 分享四要素-图片地址,
  }
  window.wx && window.wx.ready(function () {
    // 自定义“分享给朋友”及“分享到QQ”按钮的分享内容
    window.wx.updateAppMessageShareData && window.wx.updateAppMessageShareData(wxConfig) // 自定义“分享到朋友圈”及“分享到QQ空间”按钮的分享内容
    window.wx.updateTimelineShareData && window.wx.updateTimelineShareData(wxConfig)
  })
}
